var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Truck_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M13.266 13.574V3.3H.6v10.274zm0 0H19.6v-2.15a2 2 0 0 0-.382-1.176l-1.732-2.386a2 2 0 0 0-1.619-.825h-2.6zm-8.149 1.863c0-1.035-.802-1.863-1.805-1.863s-1.805.828-1.805 1.863S2.31 17.3 3.312 17.3c1.003 0 1.805-.828 1.805-1.863Zm12.667 0c0-1.035-.802-1.863-1.805-1.863s-1.805.828-1.805 1.863.802 1.863 1.805 1.863 1.805-.828 1.805-1.863Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Truck_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTruck;